/**
 * library similar to jQuery meaning can be used
 *     - carbarn.function();
 *     - carbarn(element).function();
 *
 * carbarn is not intended to extend jQuery but rather be it's own separate library
 *
 * dependencies:
 *     - jQuery
 */

(function (root, factory) {
    // if (typeof define === 'function' && define.amd) {
    //     // AMD
    //     define(['jquery'], factory);
    // } else
    if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals (Note: root is window)
        root.carbarn = factory(root.jQuery);
    }
} (this, function ($) {
    /**
     * carbarn: custom jQuery-like library in that it can be used like
     * `carbarn.function();` or `carbarn(element).function();`
     *
     * @param {*} selector
     */
    var carbarn = function(selector) {
        return new carbarn.fn.init(selector);
    };

    carbarn.fn = carbarn.prototype = {
        selector: null,
        elements: [],
        constructor: carbarn
    };

    // event handler
    carbarn.prototype.eventHandler = {
        events: [],
        bindEvent: function(event, callback, targetElement) {
            //remove any duplicate event
            this.unbindEvent(event,targetElement);

            //bind event listener to DOM element
            targetElement.addEventListener(event, callback, false);

            this.events.push({
                type: event,
                event: callback,
                target: targetElement
            }); //push the new event into our events array.
        },
        findEvent: function(event) {
            return this.events.filter(function(evt) {
                return (evt.type === event); //if event type is a match return
            }, event)[0];
        },
        unbindEvent: function(event, targetElement) {
            //search events
            var foundEvent = this.findEvent(event);

            //remove event listener if found
            if (foundEvent !== undefined) {
                targetElement.removeEventListener(event, foundEvent.event, false);
            }

            //update the events array
            this.events = this.events.filter(function(evt) {
                return (evt.type !== event);
            }, event);
        }
    };

    // initializer
    init = carbarn.fn.init = function(selector) {
        this.selector = selector || null;
        this.elements = [];

        var error_message = 'Invalid Selector / Node';

        if(this.selector) {
            switch (typeof this.selector) {
                case 'object':
                    // determine if selector is an HTML element
                    if(this.selector.nodeType) {
                        this.elements[0] = this.selector;
                    } else {
                        throw error_message;
                    }
                    break;
                case 'string':
                    if(this.selector[0] == '<') {
                        // create element
                        var matches = this.selector.match(/<([\w-]*)>/);
                        if(matches === null || matches === undefined) {
                            throw error_message;
                        }
                        var nodeName = matches[0].replace('<','').replace('>','');
                        this.elements[0] = document.createElement(nodeName);
                    } else {
                        this.elements = document.querySelectorAll(this.selector);
                    }
                    break;
                default:
                    throw error_message + "Error";
                    break;
            }
        } else {
            throw error_message;
        }
    };

    /**
     * not 100% sure what this does :)
     * stole from jQuery see: node_modules\jquery\dist\jquery.js @ line 3233
     */
    init.prototype = carbarn.fn;

    carbarn.prototype.swatches = function(options) {
        const $this = this.elements;

        const $selector = this.selector;

        var $properties = {
            colorClass: '',
        };

        for(o in options) {
            if($properties.hasOwnProperty(o)) {
                $properties[o] = options[o];
            }
        }

        $($this).on('click', function() {
            var input = $(this).closest('.swatch_group').find('input[type=radio]');

            if(input.prop('type') == 'radio') {
                $(this).closest('.swatch_container').find(`.swatch_group ${$selector}`).removeClass(`${$selector.substring(1)}_active`);
            }

            $(this).addClass(`${$selector.substring(1)}_active`);
            $(input).prop('checked', true);
        });
    };

    return carbarn;
}));